import { Link, useLocation } from "react-router-dom";
import { NetworkCanvas } from "../NetworkCanvas";
import { MaskedLine, FadeIn } from "../motion/Reveal";
import { isBlueRoute } from "../../lib/theme";

export const PageHero = ({ eyebrow, title, titleAccent, description, crumb }) => {
  const blue = isBlueRoute(useLocation().pathname);
  return (
  <section className="relative bg-nx-navy overflow-hidden pt-20 sm:pt-24 lg:pt-36 pb-16 sm:pb-20" data-testid="page-hero">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,#10203a_0%,#0a1526_60%,#060d1a_100%)]" />
    <NetworkCanvas skyline={false} className="absolute inset-0 w-full h-full opacity-45" accent={blue ? "59, 130, 246" : undefined} />
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_30%,rgba(6,13,26,0.8)_100%)]" />
    <div className="relative nx-wrap">
      <FadeIn delay={0.15}>
        <div className="flex items-center gap-3 text-[11px] tracking-[0.26em] uppercase text-slate-500 mb-6" data-testid="page-hero-crumb">
          <Link to="/" className="hover:text-nx-goldlight transition-colors">Home</Link>
          <span className="text-nx-gold/60">/</span>
          <span className="text-nx-goldlight">{crumb}</span>
        </div>
      </FadeIn>
      <div className="flex items-center gap-4 mb-5">
        <FadeIn delay={0.25}><span className="h-px w-12 bg-nx-gold/70 block" /></FadeIn>
        <FadeIn delay={0.3}><span className="text-[11px] sm:text-xs tracking-[0.3em] uppercase text-nx-goldlight">{eyebrow}</span></FadeIn>
      </div>
      <h1 className="font-marcellus text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.06] max-w-3xl" data-testid="page-hero-title">
        <MaskedLine delay={0.35}>{title}</MaskedLine>
        {titleAccent && <MaskedLine delay={0.5} innerClassName="text-nx-goldlight">{titleAccent}</MaskedLine>}
      </h1>
      {description && (
        <FadeIn delay={0.75}>
          <p className="mt-6 text-base md:text-lg text-slate-400 max-w-2xl leading-relaxed" data-testid="page-hero-description">{description}</p>
        </FadeIn>
      )}
    </div>
  </section>
  );
};
